/**
 * The backend refused to start the task before it changed anything, e.g. because
 * another task still claims the contributors; `reason` is its display text (#5182).
 */
export class PlanningTaskRejectedError extends Error {
  constructor(readonly reason: string | undefined) {
    super(reason ?? 'Planning task rejected');
  }
}
